<div class="container-fluid py-3">

  <!-- Header -->
  <div class="mb-4">
    <h4 class="fw-bold text-dark mb-1">Diario de Emociones</h4>
    <p class="text-muted mb-0">{{ todayDisplay }}</p>
  </div>

  <!-- Loading -->
  @if (isLoading) {
  <div class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
  </div>
  }

  @if (!isLoading && !showRegistro) {

  <!-- Week View -->
  <div class="card border-0 shadow-sm rounded-4 mb-4">
    <div class="card-body p-4">
      <h6 class="text-muted mb-3">Esta semana</h6>
      <div class="d-flex justify-content-between align-items-start week-row">
        @for (day of weekDays; track day.fecha) {
        <div class="text-center week-day" [class.today]="day.isToday">
          <small class="d-block mb-1 day-label">{{ day.label }}</small>
          <small class="d-block mb-2 day-number">{{ day.dayNumber }}</small>
          @if (day.emocion) {
          <img [src]="getEmotionIcon(day.emocion.emocion)"
               [alt]="day.emocion.emocion"
               class="emotion-icon-sm clickable"
               (click)="verDia(day)" />
          } @else {
          <div class="empty-circle"></div>
          }
        </div>
        }
      </div>
    </div>
  </div>

  <!-- Detail of a selected day -->
  @if (selectedDayEntry) {
  <div class="card border-0 shadow-sm rounded-4 mb-4">
    <div class="card-body text-center p-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <p class="text-muted mb-0">{{ selectedDayEntry.fecha }}</p>
        <button class="btn btn-sm btn-outline-secondary rounded-circle" (click)="cerrarDetalleDia()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <img [src]="getEmotionIcon(selectedDayEntry.emocion)"
           [alt]="selectedDayEntry.emocion"
           class="emotion-icon-lg mb-2" />
      <h5 class="fw-bold">{{ getEmotionLabel(selectedDayEntry.emocion) }}</h5>
      @if (selectedDayEntry.anotacion) {
      <div class="mt-3 p-3 bg-light rounded-3">
        <p class="text-muted mb-0 text-start">{{ selectedDayEntry.anotacion }}</p>
      </div>
      }
    </div>
  </div>
  }

  <!-- "Iniciar registro" button -->
  @if (!todayEntry && !selectedDayEntry) {
  <div class="mb-4">
    <h5 class="fw-bold text-dark mb-3">¿Cómo te sientes hoy?</h5>
    <button class="btn btn-primary btn-lg w-100 rounded-3" (click)="iniciarRegistro()">
      Iniciar registro
    </button>
  </div>
  }

  <!-- Today's entry summary -->
  @if (todayEntry && !selectedDayEntry) {
  <div class="card border-0 shadow-sm rounded-4 mb-4">
    <div class="card-body text-center p-4">
      <p class="text-muted mb-2">Tu emoción de hoy</p>
      <img [src]="getEmotionIcon(todayEntry.emocion)"
           [alt]="todayEntry.emocion"
           class="emotion-icon-lg mb-2" />
      <h5 class="fw-bold">{{ getEmotionLabel(todayEntry.emocion) }}</h5>
      @if (todayEntry.anotacion) {
      <div class="mt-3 p-3 bg-light rounded-3">
        <p class="text-muted mb-0 text-start">{{ todayEntry.anotacion }}</p>
      </div>
      }
      <button class="btn btn-outline-primary rounded-3 px-4 mt-3" (click)="editarRegistro()">
        <i class="fas fa-pen me-1"></i> Cambiar emoción
      </button>
    </div>
  </div>

  <!-- Motivational message -->
  <div class="text-center mt-3 mb-4">
    <p class="text-muted fst-italic">Estamos emocionados por saber de tu emoción mañana.</p>
  </div>
  }

  <!-- Estadísticas del mes -->
  @if (showChart && !selectedDayEntry) {
  <div class="card border-0 shadow-sm rounded-4 mb-4">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h6 class="fw-bold mb-0">Tu resumen del mes</h6>
          <small class="text-muted">{{ mesActualLabel }}</small>
        </div>
        @if (emocionFrecuente) {
        <div class="text-center">
          <img [src]="emocionFrecuente.icon" [alt]="emocionFrecuente.label" class="emotion-icon-sm" />
          <small class="d-block text-muted mt-1">Más frecuente</small>
        </div>
        }
      </div>

      <!-- Stats cards -->
      <div class="row g-2 mb-3">
        <div class="col-6">
          <div class="stat-card text-center p-3 rounded-3">
            <h4 class="fw-bold mb-0 text-primary">{{ totalRegistrosMes }}</h4>
            <small class="text-muted">Días registrados</small>
          </div>
        </div>
        <div class="col-6">
          <div class="stat-card text-center p-3 rounded-3">
            <h4 class="fw-bold mb-0 text-primary">{{ rachaActual }}</h4>
            <small class="text-muted">Racha actual</small>
          </div>
        </div>
      </div>

      <!-- Donut Chart -->
      <apx-chart
        [series]="chartSeries"
        [chart]="chartOptions.chart"
        [labels]="chartLabels"
        [colors]="chartColors"
        [legend]="chartOptions.legend"
        [dataLabels]="chartOptions.dataLabels"
        [plotOptions]="chartOptions.plotOptions"
        [stroke]="chartOptions.stroke"
        [tooltip]="chartOptions.tooltip"
        [responsive]="chartOptions.responsive">
      </apx-chart>

      <!-- Custom legend with icons -->
      <div class="row g-2 mt-3">
        @for (item of resumenEmociones; track item.emocion.key) {
        <div class="col-6">
          <div class="d-flex align-items-center gap-2 legend-item p-2 rounded-3">
            <img [src]="item.emocion.icon" [alt]="item.emocion.label" class="legend-icon" />
            <div>
              <small class="fw-medium d-block">{{ item.emocion.label }}</small>
              <small class="text-muted">{{ item.cantidad }} {{ item.cantidad === 1 ? 'día' : 'días' }}</small>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  }

  }

  <!-- Registration Flow -->
  @if (!isLoading && showRegistro) {
  <div class="registro-section">
    <h5 class="text-center fw-bold mb-1">
      {{ isEditing ? '¿Quieres cambiar tu emoción de hoy?' : '¿Qué emoción estás sintiendo en estos momentos?' }}
    </h5>
    <p class="text-center text-muted mb-4">Selecciona la opción que más te identifique</p>

    <!-- Emotion Grid -->
    <div class="row g-3 emotion-grid">
      @for (emo of emociones; track emo.key) {
      <div class="col-4 col-md-3">
        <div class="emotion-card text-center p-3"
             [class.selected]="selectedEmocion === emo.key"
             (click)="selectEmocion(emo.key)">
          <img [src]="emo.icon" [alt]="emo.label" class="emotion-icon-md mb-2" />
          <small class="d-block fw-medium">{{ emo.label }}</small>
        </div>
      </div>
      }
    </div>

    <!-- Annotation textarea -->
    @if (selectedEmocion) {
    <div class="mt-4">
      <label class="form-label fw-medium">Anotación (opcional)</label>
      <textarea class="form-control rounded-3"
                rows="3"
                maxlength="500"
                [(ngModel)]="anotacion"
                placeholder="Escribe cómo te sientes..."></textarea>
      <small class="text-muted float-end mt-1">{{ anotacion.length }}/500</small>
    </div>
    }

    <!-- Action buttons -->
    <div class="d-flex justify-content-between mt-4 pt-2">
      <button class="btn btn-outline-secondary rounded-3 px-4" (click)="cancelarRegistro()">
        Cancelar
      </button>
      <button class="btn btn-primary rounded-3 px-4"
              [disabled]="!selectedEmocion || isSaving"
              (click)="crearRegistro()">
        @if (isSaving) {
        <span class="spinner-border spinner-border-sm me-1"></span>
        }
        {{ isEditing ? 'Guardar cambios' : 'Crear registro' }}
      </button>
    </div>
  </div>
  }

</div>
